import BlockedSubscription from 'components/molecules/blocked_subscription';
import OnlineSearchFollowupForm from 'components/molecules/online_search_followup_form';
import FollowupList from 'components/organisms/followup_list';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getFollowups } from 'store/modules/followup_store/actions';
import { FollowupState, FollowupTypes } from 'store/modules/followup_store/types';
import {
  FollowupOnlineSearchState,
  FollowupOnlineSearchTypes,
} from 'store/modules/followup_online_search_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';
import BlockedSubscriptionRepresentant from 'components/molecules/blocked_subscription_representant';
import { ActivitiesState } from 'store/modules/activities_store/types';

const FollowupOnlineSearch = () => {
  const dispatch = useDispatch();

  const allowedSaleSituations = ['Ativa', 'Em Analise'];

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { request } = useSelector<ApplicationState, FollowupState>(
    (state) => state.session.followups,
  );

  const { followupOnlineSearch } = useSelector<ApplicationState, FollowupOnlineSearchState>(
    (state) => state.session.followupOnlineSearch,
  );

  const { activities } = useSelector<ApplicationState, ActivitiesState>(
    (state) => state.storage.activities,
  );
  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);

  const [currentCompany, setCurrentCompany] = useState<number>(
    profile.currentCompany[tabId()] || profile.clientId,
  );

  const fetchFollowups = () => {
    if (profile.representant && profile.currentCompany[tabId()] !== profile.company_data.data.id) {
      dispatch(
        getFollowups(
          {
            activities_list: activities[profile.currentCompany[tabId()]],
            filters: followupOnlineSearch.filters,
            page: followupOnlineSearch.currentPage,
            per_page: followupOnlineSearch.postsPerPage,
          },
          profile.currentCompany[tabId()],
        ),
      );
      return;
    }

    dispatch(
      getFollowups({
        activities_list: activities[profile.currentCompany[tabId()]],
        filters: followupOnlineSearch.filters,
        page: followupOnlineSearch.currentPage,
        per_page: followupOnlineSearch.postsPerPage,
      }),
    );
  };

  useEffect(() => {
    setCurrentCompany(profile.currentCompany[tabId()]);
  }, [profile.currentCompany[tabId()]]);

  useEffect(() => {
    document.title = 'Encontrar Acompanhamentos - ConLicitação';

    dispatch({ type: FollowupTypes.UPDATE_STORE_FIELDS });
    dispatch({ type: FollowupOnlineSearchTypes.UPDATE_STORE_FIELDS });

    fetchFollowups();
  }, [currentCompany]);

  useEffect(() => {
    if (followupOnlineSearch.currentPage === 1 && followupOnlineSearch.filters.updated) {
      fetchFollowups();
    }

    if (followupOnlineSearch.filters.updated)
      dispatch({ type: FollowupOnlineSearchTypes.UPDATE_CURRENT_PAGE, currentPage: 1 });
  }, [followupOnlineSearch.filters.updated]);

  useEffect(() => {
    if (request?.loading) return;
    fetchFollowups();
  }, [followupOnlineSearch.currentPage]);

  useEffect(() => {
    if (request?.loading) return;

    fetchFollowups();
  }, [followupOnlineSearch.postsPerPage]);

  return (
    <div className="page-container">
      {profile.representant &&
        profile.paralyzed &&
        profile.currentCompany[tabId()] === profile.clientId && (
          <BlockedSubscription paralyzed={profile.paralyzed} />
        )}
      {!profile.representant &&
        allowedSaleSituations.includes(profile.sale_situation) &&
        !profile.paralyzed && (
          <>
            <OnlineSearchFollowupForm
              searchBarOpened={searchBarOpened}
              setSearchBarOpened={setSearchBarOpened}
            />
            <FollowupList searchBarOpened={searchBarOpened} />
          </>
        )}
      {!profile.representant &&
        profile.paralyzed &&
        allowedSaleSituations.includes(profile.sale_situation) && (
          <BlockedSubscription paralyzed={profile.paralyzed} />
        )}
      {!profile.representant && !allowedSaleSituations.includes(profile.sale_situation) && (
        <BlockedSubscription paralyzed={profile.paralyzed} />
      )}
      {profile.representant &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) &&
        !profile?.represented?.filter(
          (company) => company.id === profile.currentCompany[tabId()],
        )[0]?.paralisado && (
          <>
            <OnlineSearchFollowupForm
              searchBarOpened={searchBarOpened}
              setSearchBarOpened={setSearchBarOpened}
            />
            <FollowupList searchBarOpened={searchBarOpened} />
          </>
        )}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        profile?.represented?.filter((company) => company.id === profile.currentCompany[tabId()])[0]
          ?.paralisado &&
        allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
      {profile.representant &&
        profile.currentCompany[tabId()] !== profile.clientId &&
        !allowedSaleSituations.includes(
          profile?.represented?.filter(
            (company) => company.id === profile.currentCompany[tabId()],
          )[0]?.sale_situation_name,
        ) && <BlockedSubscriptionRepresentant />}
    </div>
  );
};

export default FollowupOnlineSearch;
